import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import swal from "sweetalert";
import AnimatedPage from "../components/AnimatedPage";
import Header from "../components/Header";
import Footer from "../components/Footer";

function Login() {
    const [err, setErr] = useState(null);
    const login = localStorage.getItem("user");
    const [notify, setNotify] = useState(JSON.parse(localStorage.getItem("notify")));
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    
    const {
        register,
        handleSubmit,
        setError,
        formState: { errors }
    } = useForm();
    const navigate = useNavigate();

    useEffect(() => {
        if (login) {
            navigate("/");
        }
        
        axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {}).then((res) => {
            if (setting !== res.data.data[0]) {
                setSetting(res.data.data[0]);
                localStorage.setItem("setting", JSON.stringify(res.data.data[0]));
            }
        });
        
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getnotify`, {}).then((res) => {
            if (notify !== res.data.data) {
                setNotify(res.data.data);
                localStorage.setItem("notify", JSON.stringify(res.data.data));
            }
        });
    }, []);

    const onSubmit = async (data) => {
        const regex = /^[a-zA-Z0-9]+$/;
        if (data.username.length < 6) {
            setError("username", {
                type: "minLength",
                message: "Tên đăng nhập tối thiểu 6 kí tự"
            });
            return false;
        }
        if (!regex.test(data.username)) {
            setError("username", {
                type: "minLength",
                message: "Không chứa khoảng trắng và ký tự đặc biệt"
            });
            return false;
        }
        if (data.password.length < 6) {
            setError("password", {
                type: "minLength",
                message: "Mật khẩu tối thiểu 6 kí tự"
            });
            return false;
        }

        axios
            .post(`${process.env.REACT_APP_API_URL}/auth/login`, {
                username: data.username.toLowerCase(),
                password: data.password
            })
            .then((res) => {
                swal({
                    title: "Thông báo",
                    text: "Đăng nhập thành công",
                    icon: "success",
                    buttons: "OK"
                }).then(() => {
                    localStorage.removeItem("user");
                    localStorage.removeItem("profile");
                    localStorage.removeItem("data");
                    localStorage.setItem("user", res.data.data);
                    localStorage.setItem("password", data.password);
                    navigate("/?notify");
                });
            })
            .catch((err) => setErr(err.response?.data?.message ? err.response.data.message : "Tên đăng nhập hoặc mật khẩu không chính xác!"));
    };

    return (
        <AnimatedPage>
            {/* Thanh Header chứa Logo và Menu */}
            <Header profile={null} />

            <style>{`
                html, body, #root {
                    height: auto !important;
                    overflow-y: auto !important;
                    background-color: #e3e1e2;
                }
                .login-page-container {
                    background-color: #e3e1e2;
                    min-height: calc(100vh - 55px); 
                    display: flex;
                    justify-content: center;
                    align-items: flex-start;
                    padding-top: 35px;
                    padding-bottom: 100px; /* Chừa chỗ cho Footer */
                }
                .login-wrapper-box {
                    width: 100%;
                    max-width: 600px; /* Đã tăng max-width để form dãn rộng ra như bản gốc */
                    padding: 0 15px; /* Giảm padding 2 bên để form sát lề hơn trên mobile */
                }
                .login-title {
                    text-align: center;
                    text-transform: uppercase;
                    color: #2b3245;
                    font-weight: bold;
                    margin-bottom: 5px;
                    font-size: 24px;
                }
                .login-subtitle {
                    text-align: center;
                    color: #222;
                    font-size: 14px;
                    font-weight: 500;
                    margin-bottom: 25px;
                }
                .form-group {
                    margin-bottom: 20px;
                }
                .form-group label {
                    display: block;
                    font-size: 14px;
                    color: #555;
                    margin-bottom: 8px;
                    font-weight: 600; /* Làm đậm chữ hơn một chút */
                    text-align: left; /* ĐÃ SỬA: Căn chữ TRÁI giống hệt ảnh gốc */
                }
                .form-group label span {
                    color: #d32f2f; /* Dấu * màu đỏ */
                }
                .input-container {
                    position: relative;
                    display: flex;
                    align-items: center;
                    background: #d1d2d6; /* Màu xám đặc trưng của ô input trong ảnh */
                    border-radius: 4px;
                    overflow: hidden;
                }
                .input-container i {
                    width: 45px;
                    text-align: center;
                    color: #555;
                    font-size: 16px;
                }
                .input-container input {
                    flex: 1;
                    height: 45px;
                    border: none;
                    background: transparent;
                    outline: none;
                    color: #333;
                    font-size: 16px; /* Tăng size chữ nhập cho dễ nhìn */
                    padding: 0 10px 0 0;
                }
                .input-container input::placeholder {
                    color: #777;
                }
                .error-msg {
                    display: block;
                    text-align: left;
                    color: #d32f2f;
                    font-size: 13px;
                    margin-top: 5px;
                }
                .btn-login-submit {
                    width: 100%;
                    background: #b71c1c; /* Đỏ đun đậm giống ảnh */
                    color: #fff;
                    border: none;
                    border-radius: 4px;
                    padding: 14px;
                    font-size: 16px;
                    font-weight: bold;
                    cursor: pointer;
                    margin-top: 10px;
                    margin-bottom: 20px;
                    text-transform: uppercase;
                }
                .btn-login-submit:active {
                    background: #961616;
                }
                .register-link-box {
                    text-align: center;
                    color: #333;
                    font-size: 15px;
                }
                .register-link-box a {
                    color: #222;
                    font-weight: bold;
                    text-decoration: none;
                }
                .register-link-box a:hover {
                    text-decoration: underline;
                }
            `}</style>

            <div className="login-page-container">
                <div className="login-wrapper-box">
                    <h4 className="login-title">Đăng nhập</h4>
                    <p className="login-subtitle">Trang web trò chơi phổ biến và thú vị nhất Châu Á.</p>
                    
                    {err && <p className="error-msg" style={{ textAlign: "center", marginBottom: "15px", fontSize: "14px" }}>{err}</p>}

                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="form-group">
                            <label htmlFor="account">tên tài khoản<span>*</span></label>
                            <div className="input-container">
                                <i className="fa-solid fa-user"></i>
                                <input 
                                    type="text" 
                                    id="user" 
                                    maxLength="20" 
                                    placeholder="Tên tài khoản" 
                                    {...register("username", { required: true })}
                                />
                            </div>
                            {errors.username && <span className="error-msg">{errors.username.message}</span>}
                        </div>

                        <div className="form-group">
                            <label htmlFor="password">mật khẩu<span>*</span></label>
                            <div className="input-container">
                                <i className="fa-solid fa-lock"></i>
                                <input 
                                    type="password" 
                                    id="password" 
                                    maxLength="20" 
                                    placeholder="mật khẩu" 
                                    {...register("password", { required: true })}
                                />
                            </div>
                            {errors.password && <span className="error-msg">{errors.password.message}</span>}
                        </div>

                        <button type="submit" className="btn-login-submit">
                            ĐĂNG NHẬP
                        </button>

                        <div className="register-link-box">
                            Không có tài khoản ? <Link to="/register">ĐĂNG KÝ</Link>
                        </div>
                    </form>
                </div>
            </div>

            {/* THANH ĐIỀU HƯỚNG BÊN DƯỚI */}
            <Footer />
            
        </AnimatedPage>
    );
}

export default Login;